import { render, staticRenderFns } from "./SettingsShipAuditSchedule.vue?vue&type=template&id=b96c35e0&scoped=true&"
import script from "./SettingsShipAuditSchedule.vue?vue&type=script&lang=js&"
export * from "./SettingsShipAuditSchedule.vue?vue&type=script&lang=js&"
import style0 from "./SettingsShipAuditSchedule.vue?vue&type=style&index=0&id=b96c35e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96c35e0",
  null
  
)

export default component.exports